/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 完了通知用のoperationIdリクエスト
 * @export
 * @interface CompleteBillingsCsvRequest
 */
export interface CompleteBillingsCsvRequest {
    /**
     * アップロード処理のトラッキングID
     * @type {string}
     * @memberof CompleteBillingsCsvRequest
     */
    operationId: string;
}

/**
 * Check if a given object implements the CompleteBillingsCsvRequest interface.
 */
export function instanceOfCompleteBillingsCsvRequest(value: object): value is CompleteBillingsCsvRequest {
    if (!('operationId' in value) || value['operationId'] === undefined) return false;
    return true;
}

export function CompleteBillingsCsvRequestFromJSON(json: any): CompleteBillingsCsvRequest {
    return CompleteBillingsCsvRequestFromJSONTyped(json, false);
}

export function CompleteBillingsCsvRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteBillingsCsvRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'operationId': json['operation_id'],
    };
}

export function CompleteBillingsCsvRequestToJSON(json: any): CompleteBillingsCsvRequest {
    return CompleteBillingsCsvRequestToJSONTyped(json, false);
}

export function CompleteBillingsCsvRequestToJSONTyped(value?: CompleteBillingsCsvRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_id': value['operationId'],
    };
}

